<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte';
    import TopInfo from '../components/TopInfo.svelte';  
    import Locations from '../components/Locations.svelte'; 
    import Preloader from '../components/Preloader.svelte'; 

    let locations = [];

    if ($UserStore.settings.shipping_settings && $UserStore.settings.shipping_settings.datalogics_update_inventory_locations) {
        
        locations = $UserStore.settings.shipping_settings.datalogics_update_inventory_locations; 
        
    }



    let isLoading = false;

    
    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }        
        
    })

    const handleSubmit =  async () => {

        isLoading = true;

        console.log('locations list',locations)

        let postData = {};

        postData.action = 'w_update_shipping_methods';
        postData.token = $UserStore.data
        postData.datalogics_update_inventory_locations = locations;

        let response = await fetchData(postData);
        if (response.data) {

            $UserStore.settings = response.data;
            localStorage.setItem('user',JSON.stringify($UserStore))     
            
            alert('הנתונים נשמרו בהצלחה')

        }

        isLoading = false;

    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">

        <TopInfo />   
        
        <div class="dash-list">        
            <div class="orders-top">
                <div class="orders-top-up">
                    <h1>{$_('locations.locations')}</h1>
                    <span on:click={()=> { locations.push({'enabled' : true}); locations = locations; } } class="create_button"><span>{$_('locations.add_location')}</span></span>
                </div>
            </div>
            <Locations {locations}/>
            <div class="shipment-flex-button">
                <div class="create_button" on:click={ handleSubmit }>{$_('locations.save')}</div>
            </div>
        </div>
    </div>
</div>
